/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Online_Sections_4_TitleInputs */

const en_gc_search_guides_gridcraft_online_sections_4_title = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A focused first ten minutes online`)
};

const zh_gc_search_guides_gridcraft_online_sections_4_title = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_4_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在线试用的前十分钟`)
};

/**
* | output |
* | --- |
* | "A focused first ten minutes online" |
*
* @param {Gc_Search_Guides_Gridcraft_Online_Sections_4_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_online_sections_4_title = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Online_Sections_4_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Online_Sections_4_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_online_sections_4_title(inputs)
	return zh_gc_search_guides_gridcraft_online_sections_4_title(inputs)
});
export { gc_search_guides_gridcraft_online_sections_4_title as "gc.search_guides.gridcraft_online.sections.4.title" }